var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteHeartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5996 5.63109L12 6.16622L12.4004 5.63109C13.3204 4.40129 14.7949 3.60156 16.44 3.60156C19.2315 3.60156 21.5 5.87537 21.5 8.69156C21.5 9.82718 21.3189 10.8753 21.0043 11.8476L21.0032 11.8509C20.249 14.2376 18.7035 16.1612 17.0354 17.5949C15.365 19.0304 13.6004 19.9498 12.4589 20.3382L12.4589 20.3382L12.4536 20.3401C12.3537 20.3753 12.1893 20.4016 12 20.4016C11.8107 20.4016 11.6463 20.3753 11.5464 20.3401L11.5464 20.34L11.5411 20.3382C10.3996 19.9498 8.635 19.0304 6.96465 17.5949C5.29649 16.1612 3.75096 14.2376 2.99676 11.8509L2.99677 11.8509L2.99572 11.8477C2.68114 10.8753 2.5 9.82718 2.5 8.69156C2.5 5.87537 4.76848 3.60156 7.56 3.60156C9.2051 3.60156 10.6796 4.40129 11.5996 5.63109Z",
    fill: "#ECEEF9",
    stroke: "#D10A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteHeartIcon);
export default __webpack_public_path__ + "static/media/white-heart-icon.01e8f53b86190e83fd3b2c6fe4823cfc.svg";
export { ForwardRef as ReactComponent };